import React from "react"
import { cn } from "@/lib/utils"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts"
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent
} from "@/components/ui/chart"

interface ProgressData {
  range: string
  founders: number
}

interface CohortProgressChartProps {
  data?: ProgressData[]
  title?: string
  height?: number
  cohortId?: string
  className?: string
}

const defaultData: ProgressData[] = []

export function CohortProgressChart({
  data = defaultData,
  title = "Cohort Progress Overview",
  height = 300,
  cohortId,
  className
}: CohortProgressChartProps) {
  const handleBarClick = (entry: ProgressData) => {
    const params = new URLSearchParams()
    params.set("progress_range", entry.range)
    if (cohortId) params.set("cohort_id", cohortId)
    window.location.href = `/admin/founders?${params.toString()}`
  }

  return (
    <div className={cn("space-y-4", className)}>
      <div>
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        <p className="text-sm text-muted-foreground">
          Distribution of founder progress across the cohort. Click a bar to view founders.
        </p>
      </div>

      {data.length === 0 ? (
        <div className="flex items-center justify-center text-muted-foreground" style={{ height: `${height}px` }}>
          <p className="text-sm">No progress data available yet</p>
        </div>
      ) : (
        <ChartContainer
          config={{}}
          className={cn("w-full aspect-none")}
          style={{ height: `${height}px` }}
        >
          <BarChart data={data} className="cursor-pointer">
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
            <XAxis
              dataKey="range"
              stroke="hsl(var(--muted-foreground))"
              fontSize={12}
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              stroke="hsl(var(--muted-foreground))"
              fontSize={12}
              tickLine={false}
              axisLine={false}
              label={{
                value: "Number of Founders",
                angle: -90,
                position: "insideLeft",
                style: { fill: "hsl(var(--muted-foreground))", fontSize: 12 }
              }}
            />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Bar
              dataKey="founders"
              fill="#c96642"
              radius={[4, 4, 0, 0]}
              onClick={(_data: unknown, index: number) => handleBarClick(data[index])}
              style={{ cursor: "pointer" }}
            />
          </BarChart>
        </ChartContainer>
      )}
    </div>
  )
}